import React from "react";

const FAQSection: React.FC = () => {
  return (
    <div className="mt-16 max-w-3xl mx-auto">
      <div className="space-y-6">
        <div className="border border-gray-200 rounded-lg overflow-hidden">
          <details className="group">
            <summary className="flex justify-between items-center p-4 cursor-pointer bg-white hover:bg-gray-50">
              <h3 className="text-lg font-medium text-gray-800">
                When will I hear from you?
              </h3>
              <span className="transition group-open:rotate-180">
                <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M6 9l6 6 6-6"
                  ></path>
                </svg>
              </span>
            </summary>
            <div className="p-4 pt-0 text-gray-700">
              <p>
                We'll email you when market rates drop enough to make
                refinancing worthwhile for your specific situation. This could
                be in a few weeks, months, or longer - it all depends on market
                conditions. You can always check current rates or speak with a
                mortgage expert if you have questions.
              </p>
            </div>
          </details>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
